module.exports = __webpack_public_path__ + "fonts/3ff7b647-ed35-4a34-a497-0b8e0455ef09.86369766.eot";